import { deleteAuthCookies, setCookie } from 'utils/Cookie'
import { TOKEN_KEYS } from 'const/settings'

class AuthApi {
  constructor (ctx) {
    this.ctx = ctx
  }

  postRegistration = async (params) => {
    const res = await this.ctx.post('/user/', params)

    return res.data
  }

  postFastRegistration = async (params) => {
    const res = await this.ctx.post('/user/login/via_phone/', params)

    return res.data
  }

  postConfirmPhoneForFastRegistration = async (params) => {
    const res = await this.ctx.post('/user/login/via_phone_confirm/', params)

    setCookie(TOKEN_KEYS.AUTH_TOKEN_KEY, res.data.token)

    return res.data
  }

  postLogin = async (params) => {
    const res = await this.ctx.post('/user/login/', params)

    setCookie(TOKEN_KEYS.AUTH_TOKEN_KEY, res.data.token)

    return res.data
  }

  postRestorePassword = async (params) => {
    const res = await this.ctx.post('/user/restore_password/', params)

    return res.data
  }

  postRestorePasswordSetPassword = async (params) => {
    const res = await this.ctx.post('/user/restore_password_set_password/', params)

    return res.data
  }

  postLogout = async () => {
    await this.ctx.post('/user/logout/')
    deleteAuthCookies()
  }
}

export default AuthApi
